var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unbox"},[_c('div',{staticClass:"unbox-header"},[(_vm.unboxGetRouteName === 'UnboxOverview')?_c('UnboxHeaderOverview'):(_vm.unboxGetRouteName === 'UnboxBox')?_c('UnboxHeaderBox'):_vm._e()],1),_c('div',{staticClass:"unbox-content"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }